// Constants for Document Editor Canvas
export const A4_WIDTH = 794;
export const A4_HEIGHT = 1123;
export const PAGE_MARGIN = 50;

export const BASE_SNAP_THRESHOLD = 6;
export const MAX_HISTORY_STATES = 50;
export const HISTORY_DEBOUNCE_MS = 300;

export const DUPLICATE_OFFSET = 20;
export const PASTE_OFFSET = 15;

export const EDITOR_STRINGS = {
  MAGNET_ACTIVE: 'Ímã Ativo',
  MAGNET_OFF: 'Ímã Off',
  ALIGN_HEADER: 'Alinhar:',
  ALIGN_LEFT: 'Alinhar à Esquerda',
  ALIGN_CENTER_H: 'Centralizar Horizontalmente',
  ALIGN_RIGHT: 'Alinhar à Direita',
  ALIGN_TOP: 'Alinhar ao Topo',
  ALIGN_CENTER_V: 'Centralizar Verticalmente',
  ALIGN_BOTTOM: 'Alinhar à Base',
  IMAGE_LOAD_ERROR: 'Erro ao carregar a imagem. Verifique a URL fornecida.',
  JSON_LOAD_ERROR: 'Erro ao carregar os dados do documento.',
} as const;
